import { useDispatch, useSelector } from 'react-redux';
import {
  getConversationsList,
  resetAllFilter,
  setActiveConversation,
  setConversationFilterValues,
  setHelpMenuOpen,
  setLeftMenuOpen,
  setMessagesBoxWidth,
  setRightMenuOpen
} from '../../../redux/slices/communication';
import { LOCATION_FILTER, MESSAGES_BOX } from '../constants';
import SideBarMenu from './sidebarMenu';
import { getCurrentLocationUUID } from '../../../utils/communicationUtils';
import { COMMUNICATION_SUPPORTED_PLATFORMS } from '../../../config/communication';
import { PATH_PAGE } from '../../../routes/paths';
import { useParams } from 'react-router-dom';

export default function MainSideBarMenu() {
  const { locationslug } = useParams();
  const {
    ui: { leftMenuOpen, helpMenuOpen },
    data: {
      notifications: { data },
      locations,
      filters: { platforms }
    },
    components: { messagesBox }
  } = useSelector((state) => state.communication);
  const dispatch = useDispatch();
  const resetPlatforms = [
    {
      icon: 'fa-duotone fa-earth-americas',
      text: 'lomavis_communication.mainMenu.all_platforms',
      color: 'primary',
      platform: true,
      onClick: () => {
        if (platforms.length === 0) return;
        dispatch(setActiveConversation(null));
        dispatch(setConversationFilterValues({ platforms: [] }));
        dispatch(getConversationsList());
      },
      name: 'reset_platforms',
      active: true,
      top: true,
      currentlyActive:
        platforms.length === 0 ||
        platforms.length === COMMUNICATION_SUPPORTED_PLATFORMS.length
    }
  ];
  const q = COMMUNICATION_SUPPORTED_PLATFORMS.map((item) => {
    return {
      icon: item.icon,
      platform: true,
      color: item.color,
      text: item.platform,
      onClick: () => {
        dispatch(setActiveConversation(null));
        let uniquePlatforms = platforms.includes(item.platform)
          ? platforms.filter((platform) => platform !== item.platform)
          : [...platforms, item.platform];
        if (uniquePlatforms.length === COMMUNICATION_SUPPORTED_PLATFORMS.length)
          uniquePlatforms = [];
        dispatch(
          setConversationFilterValues({
            platforms: uniquePlatforms
          })
        );
        dispatch(getConversationsList());
      },
      active: true,
      name: item.platform,
      top: true,
      currentlyActive: platforms.includes(item.platform),
      indicator: data?.conversations.platforms?.[item.platform] > 0,
      indicatorValue: data?.conversations.platforms?.[item.platform]
    };
  });

  const buttons = [
    {
      icon: 'fa-duotone fa-envelope',
      text: 'lomavis_communication.mainMenu.all_messages',
      onClick: () => {
        dispatch(resetAllFilter());
        dispatch(setActiveConversation(null));
        // adjust url to remove conversation uuid
        window.history.pushState(
          null,
          null,
          !getCurrentLocationUUID()
            ? PATH_PAGE.communication_without_uuid
            : PATH_PAGE.location_communication_without_uuid.replace(
                ':locationslug',
                locationslug
              )
        );
        dispatch(getConversationsList());
      },
      name: MESSAGES_BOX,
      active: true,
      top: true,
      indicator: data?.conversations.unread_count > 0,
      indicatorValue: data?.conversations.unread_count,
      currentlyActive: leftMenuOpen === MESSAGES_BOX || !leftMenuOpen
    },
    /*{
      icon: 'fa-duotone fa-question-circle',
      text: 'lomavis_communication.mainMenu.help',
      onClick: () => dispatch(setHelpMenuOpen(!helpMenuOpen)),
      top: false,
      active: true,
      name: 'HELP',
      currentlyActive: helpMenuOpen
    },*/
    !getCurrentLocationUUID() && {
      icon: 'fa-duotone fa-sliders',
      text: 'lomavis_communication.mainMenu.locations',
      indicator: true && locations?.length > 0,
      indicatorValue: locations?.length,
      name: LOCATION_FILTER,
      top: true,
      onClick: () => {
        if (leftMenuOpen === LOCATION_FILTER) return;

        dispatch(setLeftMenuOpen(LOCATION_FILTER));
      },
      active: true
    }

    // {
    //   icon: 'fa-duotone fa-rectangle-history',
    //   text: 'lomavis_communication.mainMenu.collections',
    //   onClick: () => {}
    // },
    // {
    //   icon: 'fa-duotone fa-tags',
    //   text: 'lomavis_communication.mainMenu.tags',
    //   onClick: () => {}
    // }
  ];

  return (
    <SideBarMenu
      buttons={buttons
        .concat(resetPlatforms)
        .concat(q)
        .filter((item) => item)}
      activeButton={leftMenuOpen}
      showSeperator={true}
    />
  );
}
